import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import Toast from '../UI/Toast';

const CancelPayment = () => {
    const navigate = useNavigate();
    const [toast, setToast] = useState({
        show: false,
        type: '',
        message: ''
    });

    useEffect(() => {
        const handleCancellation = async () => {
            try {
                await api.post('/add_to_cancel_list');
                setToast({
                    show: true,
                    type: 'info',
                    message: 'We are sorry to see you go. You will be redirected in a few seconds...'
                });
                
                // Redirection après 3 secondes
                setTimeout(() => {
                    navigate('/app');
                }, 3000);
                
            } catch (error) {
                console.error('Error during cancellation:', error);
                setToast({
                    show: true,
                    type: 'error',
                    message: 'An error occurred. You will be redirected...'
                });
                
                // Redirection en cas d'erreur après 2 secondes
                setTimeout(() => {
                    navigate('/app');
                }, 2000);
            }
        };

        handleCancellation();
    }, [navigate]);

    return (
        <div className="cancel-payment-container" style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            minHeight: '100vh',
            backgroundColor: '#f5f5f5'
        }}>
            <div style={{ textAlign: 'center' }}>
                <h2>Payment Cancelled</h2>
                <p>We hope to see you again soon!</p>
            </div>
            
            {toast.show && (
                <Toast
                    type={toast.type}
                    message={toast.message}
                    onClose={() => setToast({ ...toast, show: false })}
                />
            )}
        </div>
    );
};

export default CancelPayment; 